import React, { useCallback, useEffect, useMemo, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Box, Button, Radio, Stack } from '@mui/material'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import Lineinput from '../../../common/lineinput'
import Modal from '../../../common/modal'
import { PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useAtom } from 'jotai'
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms'
import { removeDuplicatesFromArray } from '../../../common/helper'

const blankMpesaConfig = {
    consumerKey: '',
    secretKey: '',
    paybillNumber: '',
    passKey: '',
}

const MpesaConfigurationModel = (props) => {
    const { updateModal, loginData, selEditLuggageSetting, companyMpesaSettingData, handleSaveSetting } = props
    const [, setAlert] = useAtom(alertAtom)
    const mpesaSettingList = useMemo(
        () => (Array.isArray(companyMpesaSettingData) ? companyMpesaSettingData : companyMpesaSettingData ? [companyMpesaSettingData] : []),
        [companyMpesaSettingData]
    )
    const modalStyle = useMemo(() => ({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            paddingTop: "10px"
        }), []);
    const [configType, setConfigType] = useState('company')
    const [sourceBranchList, setSourceBranchList] = useState([])
    const [selSourceBranch, setSelSourceBranch] = useState()
    const [mpesaConfig, setMpesaConfig] = useState(blankMpesaConfig)
    const bindMpesaConfig = useCallback((configData) => {
        setMpesaConfig({
            consumerKey: configData?.ConsumerKey || '',
            secretKey: configData?.ConsumerSecretKey || '',
            paybillNumber: configData?.PayBillNo || '',
            passKey: configData?.Passkey || '',
        })
    }, [])
    const getMpesaConfigByBranch = useCallback(
        (branchID) => mpesaSettingList.find((item) => Number(item?.BranchID || 0) === Number(branchID || 0)),
        [mpesaSettingList]
    )

    useEffect(() => {
        const obj = {
            intUserID: 0,
            intCompanyID: selEditLuggageSetting?.CompanyID || 0,
            intBranchID: 0,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
            if (res.status === 'Success') {
                const list = res?.Data?.Table || []
                setSourceBranchList(list)
            } else {
                setSourceBranchList([])
                setAlert({ show: true, msg: res?.ErrMessage || 'Branch list not found', nextId: '' })
            }
        })
    }, [selEditLuggageSetting?.CompanyID, setAlert])

    useEffect(() => {
        setConfigType('company')
        setSelSourceBranch()
        bindMpesaConfig(getMpesaConfigByBranch(0))
    }, [bindMpesaConfig, companyMpesaSettingData, getMpesaConfigByBranch])

    const handleConfigTypeChange = (type) => {
        setConfigType(type)
        if (type === 'company') {
            setSelSourceBranch()
            bindMpesaConfig(getMpesaConfigByBranch(0))
        } else {
            setSelSourceBranch()
            setMpesaConfig(blankMpesaConfig)
        }
    }

    const handleBranchChange = (val) => {
        setSelSourceBranch(val)
        bindMpesaConfig(getMpesaConfigByBranch(val?.BranchID))
    }

    const handleMpesaChange = (e) => {
        const { name, value } = e.target
        setMpesaConfig((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleSaveMpesaConfig = () => {
        if (configType === 'branch' && !selSourceBranch?.BranchID) {
            setAlert({ show: true, msg: 'Please select branch', nextId: 'mpesaBranch' })
            return
        }

        const loginBranchID = loginData?.inBranchID || loginData?.intBranchID || 0
        const mpesaBranch = configType === 'company' ? 0 : Number(selSourceBranch?.BranchID || 0)
        const mpesaPayload = {
            BaseUserID: loginBranchID,
            UserID: loginBranchID,
            MpesaBranch: mpesaBranch,
            MpesaConsumerKey: mpesaConfig.consumerKey,
            MpesaSecretKey: mpesaConfig.secretKey,
            MpesaPaybillNo: mpesaConfig.paybillNumber,
            MpesaPassKey: mpesaConfig.passKey,
        }
        handleSaveSetting(mpesaPayload, updateModal, 'Mpesa configuration updated successfully')
    }

    const renderInputRow = (label, id, name) => (
        <Stack direction="row" alignItems="center" spacing={2} sx={{ marginBottom: '20px',width: '100%',display:'flex',justifyContent:'center' }}>
            <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '100%' }}>
                <Lineinput
                    id={id}
                    name={name}
                    label={label}
                    value={mpesaConfig[name]}
                    onChange={handleMpesaChange}
                    style={{ width: '100%' }}
                />
            </Item>
        </Stack>
    )

  return (
    <>
            <Modal
                headTxt="Mpesa configuration"
                width="30%"
                updateModal={updateModal}
                closeId="closeButton"
                modalClass="booking-popup"
                modalStyle={modalStyle}
            >
                <Box
                    className="BranchPageTabContainer scrollBlue"
                    sx={{
                        minHeight: '44vh',
                        overflowY: 'auto',
                        padding: '20px 45px',
                        fontFamily: 'Roboto',
                        fontSize: '16px',
                        color: '#444',
                        width:'100%'
                    }}
                >
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={5} sx={{ marginBottom: '24px',width: '100%' }}>
                        <label htmlFor="mpesaCompanyWise" style={{ display: 'flex', alignItems: 'center', fontWeight: '700',justifyContent:'left',width:'50%' }}>
                            <Radio
                                id="mpesaCompanyWise"
                                checked={configType === 'company'}
                                onChange={() => handleConfigTypeChange('company')}
                                name="mpesaConfigType"
                            />
                            Company Wise
                        </label>
                        <label htmlFor="mpesaBranchWise" style={{ display: 'flex', alignItems: 'center', fontWeight: '700',justifyContent:'left',width:'50%' }}>
                            <Radio
                                id="mpesaBranchWise"
                                checked={configType === 'branch'}
                                onChange={() => handleConfigTypeChange('branch')}
                                name="mpesaConfigType"
                            />
                            Branch Wise
                        </label>
                    </Stack>

                    {configType === 'branch' ? (
                        <Stack direction="row" alignItems="center" spacing={2} sx={{ marginBottom: '20px' }}>
                            {/* <div style={{ width: '25%', textAlign: 'right', fontWeight: '700' }}>Branches:</div> */}
                            <Item sx={{ ...sx.itemsx, width: '100%' }}>
                                <DropDownOA
                                    label="Select Branch"
                                    id="mpesaBranch"
                                    data={removeDuplicatesFromArray(sourceBranchList, 'BranchID') || []}
                                    defaultvalue={selSourceBranch?.BranchName || selSourceBranch || ''}
                                    onSelect={handleBranchChange}
                                    noCross={true}
                                    idKey="BranchID"
                                    dataKey="BranchName"
                                    minWidth="100%"
                                    nextId="mpesaConsumerKey"
                                />
                            </Item>
                        </Stack>
                    ) : null}

                    {renderInputRow('Consumer Key', 'mpesaConsumerKey', 'consumerKey')}
                    {renderInputRow('Secret Key', 'mpesaSecretKey', 'secretKey')}
                    {renderInputRow('Paybill Number', 'mpesaPaybillNumber', 'paybillNumber')}
                    {renderInputRow('Pass Key', 'mpesaPassKey', 'passKey')}

                    <Stack direction="row" justifyContent="right" spacing={4}>
                        <Button
                            variant="contained"
                            id="closeBtn"
                            className="btn btn-primary"
                            onClick={() => updateModal(false)}
                            sx={{ backgroundColor: '#ff5200', color: '#fff', width: '120px' }}
                        >
                            close
                        </Button>
                        <Button
                            variant="contained"
                            id="saveBtn"
                            className="btn btn-primary"
                            onClick={handleSaveMpesaConfig}
                            sx={{ backgroundColor: '#ff5200', color: '#fff', width: '120px' }}
                        >
                            save
                        </Button>
                    </Stack>
                </Box>
            </Modal>

        </>
  )
}

export default MpesaConfigurationModel
